const Emoji = (props) => (
  <svg
    width={20}
    height={21}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.172 13.196a4 4 0 0 0 5.656 0M13 8.367h-.01m-5.99 0h-.01m-5.99 2a9 9 0 1 0 18 0 9 9 0 0 0-18 0Z"
      stroke={props.color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Emoji;
